import { DownloadFileButton } from "@/components/Buttons/DownloadFileButton"
import { SharedDataStatusTag } from "@/components/DomainTag/SharedDataStatusTag"
import { CheckIcon } from "@/components/Icons"
import { SheetField, SheetFieldGrid, SheetSection } from "@/components/Sections/SheetSection"
import { getSharedEntityType } from "@/domain/sharedData/getSharedUtils"
import type { SharedDataJsonldReadCollectionSharedData } from "@/networking/api"
import { isNotBlank, isNullOrUndefined } from "@/utils/ts-utils"
import { FormattedMessage, useIntl } from "react-intl"

type Props = {
  entity: SharedDataJsonldReadCollectionSharedData
}

export const EndSection = ({ entity }: Props) => {
  const intl = useIntl()

  if (isNullOrUndefined(entity.interBu)) return null

  return (
    <SheetSection title={intl.formatMessage({ id: "userSharedData.end" })} icon={CheckIcon}>
      <SheetFieldGrid>
        <SheetField label={intl.formatMessage({ id: "userSharedData.end.status" })}>
          <SharedDataStatusTag status={entity.status?.code} />
        </SheetField>
        {isNotBlank(entity.interBu?.subjectEnd) && (
          <SheetField label={intl.formatMessage({ id: "userSharedData.end.motivation" })}>
            <FormattedMessage
              id={`userSharedData.${getSharedEntityType(entity)}.motivation.${entity.interBu?.subjectEnd}`}
            />
          </SheetField>
        )}
        {isNotBlank(entity.interBu?.messageEnd) && (
          <SheetField label={intl.formatMessage({ id: "userSharedData.end.message" })}>
            {entity.interBu?.messageEnd}
          </SheetField>
        )}
        {isNotBlank(entity.interBu?.attachmentUrl) && (
          <SheetField label={intl.formatMessage({ id: "userSharedData.result_doc" })}>
            <DownloadFileButton
              fileName={entity.interBu?.attachmentName}
              fileUrl={entity.interBu?.attachmentUrl}
              fileSize={`${entity.interBu?.attachmentSize}`}
              infosOnSameLine={true}
            />
          </SheetField>
        )}
      </SheetFieldGrid>
    </SheetSection>
  )
}
